@if (visibility) {
  <p class="tc__visibility">
    <mat-icon inline aria-hidden="true">{{ visible ? 'visibility' : 'visibility_off' }}</mat-icon>
    {{ visibility | translate }}
  </p>
}

@for (text of texts; track text.field) {
  <section class="tc__field" [attr.aria-label]="text.label | translate">
    <h4 class="tc__label">{{ text.label | translate }}</h4>

    @switch (text.format) {
      @case ('number') {
        <p class="tc__value">
          @if (text.before !== null && !isNew) {
            <span class="tc__value-before">{{ text.before }}</span>
            <mat-icon class="tc__value-arrow" inline aria-hidden="true">arrow_right_alt</mat-icon>
            <span class="cdk-visually-hidden">{{ 'diventa' | translate }}</span>
          }
          <span class="tc__value-after">{{ text.after ?? '–' }}</span>
        </p>
      }

      @case ('color') {
        <p class="tc__value">
          @if (text.before && !isNew) {
            <span class="tc__value-before tc__color"><span class="tc__swatch" [style.background]="text.before"></span>{{ text.before }}</span>
            <mat-icon class="tc__value-arrow" inline aria-hidden="true">arrow_right_alt</mat-icon>
            <span class="cdk-visually-hidden">{{ 'diventa' | translate }}</span>
          }
          @if (text.after) {
            <span class="tc__value-after tc__color"><span class="tc__swatch" [style.background]="text.after"></span>{{ text.after }}</span>
          } @else {
            <span class="tc__empty">{{ 'Colore tolto' | translate }}</span>
          }
        </p>
      }

      @case ('pairs') {
        <ul class="tc__list">
          @for (item of text.items; track $index) {
            <li [class]="'tc__item tc__item--' + item.state">
              @switch (item.state) {
                @case ('added') { <span class="cdk-visually-hidden">{{ 'Aggiunto' | translate }}: </span><ins class="tc__pair-title">{{ item.text }}</ins> }
                @case ('removed') { <span class="cdk-visually-hidden">{{ 'Tolto' | translate }}: </span><del class="tc__pair-title">{{ item.text }}</del> }
                @default { <span class="tc__pair-title">{{ item.text }}</span> }
              }
              @if (item.detail) {
                <span class="tc__pair-detail">{{ item.detail }}</span>
              }
            </li>
          } @empty {
            <li class="tc__empty">{{ 'Elenco svuotato' | translate }}</li>
          }
        </ul>
      }

      @case ('list') {
        <ul class="tc__list">
          @for (item of text.items; track $index) {
            <li [class]="'tc__item tc__item--' + item.state">
              @switch (item.state) {
                @case ('added') { <span class="cdk-visually-hidden">{{ 'Aggiunto' | translate }}: </span><ins>{{ item.text }}</ins> }
                @case ('removed') { <span class="cdk-visually-hidden">{{ 'Tolto' | translate }}: </span><del>{{ item.text }}</del> }
                @default { {{ item.text }} }
              }
            </li>
          } @empty {
            <li class="tc__empty">{{ 'Elenco svuotato' | translate }}</li>
          }
        </ul>
      }

      @case ('html') {
        @if (text.after) {
          <div class="tc__page" [class.tc__page--closed]="text.long && !opened.has(text.field)">
            <div class="tc__html" [innerHTML]="text.after"></div>
          </div>
        } @else {
          <p class="tc__empty">{{ 'Testo svuotato' | translate }}</p>
        }
        <div class="tc__tools">
          @if (text.long) {
            <button type="button" class="tc__link" [attr.aria-expanded]="opened.has(text.field)" (click)="toggle(opened, text.field)">
              {{ (opened.has(text.field) ? 'Riduci' : 'Leggi tutto') | translate }}
            </button>
          }
          @if (text.before && !isNew) {
            <button type="button" class="tc__link tc__link--quiet" [attr.aria-expanded]="showingBefore.has(text.field)" (click)="toggle(showingBefore, text.field)">
              {{ (showingBefore.has(text.field) ? 'Nascondi il testo attuale' : 'Confronta con il testo attuale') | translate }}
            </button>
          }
        </div>
        @if (text.before && showingBefore.has(text.field)) {
          <div class="tc__page tc__page--before">
            <div class="tc__html" [innerHTML]="text.before"></div>
          </div>
        }
      }

      @default {
        @if (text.after) {
          <p class="tc__after">{{ text.after }}</p>
        } @else {
          <p class="tc__empty">{{ 'Testo svuotato' | translate }}</p>
        }
        @if (text.before && !isNew) {
          <p class="tc__before"><span class="tc__before-label">{{ 'Prima' | translate }}</span> {{ text.before }}</p>
        }
      }
    }
  </section>
}
